






















import { Watch, Component, Vue } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { namespace } from 'vuex-class'
import userflow from 'userflow.js'
const ui = namespace('ui')

@Component
export default class App extends Vue {
    showSidebar: boolean = false
    showScrollbar: boolean = false
    noBackground: boolean = false
    @ui.State readonly minimalizedNav!: boolean
    @ui.Action minimizeNav!: () => Promise<void>
    @ui.Action maximizeNav!: () => Promise<void>

    @Watch('$route')
    onRouteChange(to: Route) {
        this.showSidebar = to.meta.showSidebar ?? true
        this.showScrollbar = to.meta.showScrollbar ?? true
        this.noBackground = to.meta.noBackground ?? true

        // never show sidebar without user or company
        if (!this.$currentUser || !this.$currentCompany) {
            this.showSidebar = false
        }

        if (this.canEnableUserflow) {
            if (userflow.isIdentified()) {
                userflow.updateUser({
                    route_name: to.name,
                    route_path: to.path,
                    route_fullpath: to.fullPath,
                })
            }
        }
    }

    async mounted() {

        // Fix header dissapearing after HMR.
        this.onRouteChange(this.$route)

        if (this.canEnableUserflow) {
            this.initUserflow()
            this.initUserflowIdentity()
        }
    }

    initUserflow() {
        userflow.init(process.env.VUE_APP_USERFLOW_TOKEN)
    }

    @Watch('$currentUser')
    initUserflowIdentity() {
        if (this.$currentUser) {
            userflow.identify(this.$currentUser.id, {
                name: this.$currentUser.firstname,
                email: this.$currentUser.email,
                signed_up_at: this.$currentUser.createdAt,
                role: this.$currentUser.role,
                route_name: this.$route.name,
                route_path: this.$route.path,
                route_fullpath: this.$route.fullPath,
            })
        } else {
            userflow.reset()
        }
    }

    get canEnableUserflow(): boolean {
        return process.env.VUE_APP_USERFLOW_TOKEN
            && process.env.VUE_APP_USERFLOW_TOKEN.length > 0
    }

    get showHeader(): boolean {
        return this.showSidebar
            && this.$currentCompany !== null
            && this.$currentUser !== null
    }

    get componentClasses() {
        return {
            'app': true,
            'app--beta-one': this.$currentUser?.betaOptInEnabled,
        }
    }
}
